<div class="col-md-6 offset-md-3 mt-5">
  <!-- <div class="alert alert-info">
  Username: test<br />
  Password: test
</div> -->
<div class="ng-container forget-username-logo">
  <img src="assets/login-logo.png">
</div>
<div class="card">
  <h5 class="card-header">Entrarit - Forget Username</h5>
  <div class="card-body">
    <form [formGroup]="forgetUsernameForm" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label class="sr-only" for="email">Email</label>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
          </div>
          <input type="email" formControlName="email" class="form-control py-0" name="email" id="email"  placeholder="Email" [pattern]="emailPattern"  [ngClass]="{ 'is-invalid': submitted && f.email.errors }" >
          @if (submitted && f.email.errors) {
            <div class="invalid-feedback">
              @if (f.email.errors.required) {
                <div>Email is required</div>
              }
            </div>
          }
          @if (f.email && f.email.errors?.pattern) {
            <div class="invalid-feedback">
              Email address is not valid
            </div>
          }
        </div>
      </div>

      <button [disabled]="loading" class="btn btn-success float-right">
        @if (loading) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
        Send email <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
      </button>
      @if (error) {
        <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
      }
    </form>
  </div>
</div>
</div>